import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { isRejectedAction } from '../sliceHelpers';
import { IClientsFilterListSliceInitialState } from './clientsFilterListTypes';
import { getClientsFilterList } from './clientsFilterListActions';

const initialState: IClientsFilterListSliceInitialState = {
  list: [],
  isLoading: false,
  errorMessage: '',
};

export const clientsFilterListSlice = createSlice({
  name: '@@clientsFilterList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClientsFilterList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getClientsFilterList.fulfilled, (state, action) => {
      state.list = action.payload.list;
      state.isLoading = false;
    });
    builder.addMatcher(isRejectedAction, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    });
  },
});

export const clientsFilterListSelector = createSelector(
  [(state: RootState) => state.clientsFilterList.list],
  (list) => list
);
